import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ARCHIVED_COMPANIES_ROUTE } from '../shared/constants/routes';
import { ArchivedCompaniesComponent } from './archived-companies/archived-companies.component';

const routes: Routes = [
  {
    path: ARCHIVED_COMPANIES_ROUTE,
    component: ArchivedCompaniesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArchivedCompaniesRoutingModule {}
